import React, { useEffect, useState } from 'react';
import './DocumentLoader.css';

const messages = [
  "Anahtar kelimeler bulunuyor...",
  "Kaynaklar taranıyor...",
  "Akademik eserler analiz ediliyor...",
  "Veriler işleniyor...",
  "Akademik makaleniz oluşturuluyor...",
  "İleri sorular hazırlanıyor...",
  "Son kontroller yapılıyor..."
];


const DocumentLoader = () => {
  const [progress, setProgress] = useState(0);
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    // Progress her 100ms artacak
    const interval = setInterval(() => {
      setProgress(old => {
        if (old >= 100) return 100;
        return old + 1;
      });
    }, 100);

    // Mesajlar 2 saniyede bir değişsin
    const msgInterval = setInterval(() => {
      setMsgIndex(old => (old + 1) % messages.length);
    }, 10000);

    return () => {
      clearInterval(interval);
      clearInterval(msgInterval);
    };
  }, []);

  return (
    <div className="document-loader">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
      <div className="loader-bar-background">
        <div
          className="loader-bar-progress"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="loader-message">{messages[msgIndex]}</div>
    </div>
  );
};

export default DocumentLoader;
